import {Section, Container} from "./Accordion";

export const Accordion = {Section, Container};
